export default __webpack_public_path__ + "static/media/iSoftbet.511100b3.png";